import EventEmitter from '@/helpers/EventEmitter'
import Raf from '@/helpers/Raf'
import { clamp, map } from '@/helpers/MathUtils'
import store from 'src/store'
import router from '@/router'
import 'url-search-params-polyfill'
import ResizeService from 'src/services/ResizeService'
import { TweenMax } from 'gsap'

const ANDROID_CHROME = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) && store.state.browser.isAndroid);
const STATES = store.state.swipeup.STATES;
const INPUT_STATES = store.state.swipeup.INPUT_STATES;

const Events = {
    Progress: 'Event.Progress',
    Set: {
        Lock: 'Set.Lock',
        State: 'Set.State',
        InputState: 'Set.InputState'
    }
}

class SwipeService {

    // SETUP ---------------------------------------------------------------

    constructor() {

        Object.assign(this, EventEmitter);

        // transition props
        this.touch = {
            start: 0,
            end: 0,
            delta: 0,
            threshold: 135
        };

        this.eventsAdded = false;

        // Used to detect when the screen is in min ui
        this.deviceDimensions = {
            portrait: {
                width: null,
                height: null
            },
            portraitMinUI: {
                width: null,
                height: null
            },
            landscape: {
                width: null,
                height: null
            },
            landscapeMinUI: {
                width: null,
                height: null
            }
        };

        this.setup();
        this.onResize();
        this.addEvents();
    }

    setup() {
        
    }

    resize() {
        // manually set rootnode to innerHeight so content stays visible
        var vh = window.innerHeight; //this.$window.height();
        //this.rootNode.style.height = vh + 15 + 'px';

        TweenMax.killTweensOf(this.onResizeDelay);
        TweenMax.delayedCall(0.1, this.onResizeDelay);
    }

    onResizeDelay() {
        window.scrollTop = 0; 
    }

    addEvents() {

        if(!this.eventsAdded){

            console.log('addEvents')

            window.addEventListener('resize', this.onResize );

            // Have to pass through {passive:false} to override chrome defaulting to true,
            // which stops preventDefault from working
            window.addEventListener('touchmove', this.onInputMove , {
                passive: false
            });
     

            // if (ANDROID_CHROME) {
            //     window.addEventListener('scroll', this.onScroll.bind(this));
            // }

            window.addEventListener('touchstart', this.onTouchStart );
            window.addEventListener('touchend', this.onTouchEnd );

            this.eventsAdded = true;
        }
    }

    removeEvents() {


        if( this.eventsAdded){ 
            window.removeEventListener('resize', this.onResize );

            // Have to pass through {passive:false} to override chrome defaulting to true,
            // which stops preventDefault from working
            window.removeEventListener('touchmove', this.onInputMove , {
                passive: false
            });
     

            // if (ANDROID_CHROME) {
            //     window.addEventListener('scroll', this.onScroll.bind(this));
            // }

            window.removeEventListener('touchstart', this.onTouchStart );
            window.removeEventListener('touchend', this.onTouchEnd );

            this.eventsAdded = false;
        }
    }


    // HANDLERS -------------------------------------------------------------
 
    onScroll(event) {
        let scrollTop = window.scrollTop; 
        if (scrollTop > this.touch.threshold) {
            this.emit(Events.Set.State, STATES.IN_MIN_UI);
        }
    }

    onTouchStart = (event) => {
        this.touch.start = event.targetTouches[0].clientY;
        this.emit(Events.Set.InputState, INPUT_STATES.DOWN);
    }

    onTouchEnd = (event) => {

        this.touch.end = event.changedTouches[0].clientY;
        this.touch.delta = (this.touch.end - this.touch.start);

        if (Math.abs(this.touch.delta) >= this.touch.threshold && this.touch.delta < 0) {

            //messy af
            this.emit(Events.Set.InputState, INPUT_STATES.COMPLETE);
            this.emit(Events.Set.State, STATES.IN_MIN_UI); 
        } else {
            this.emit(Events.Set.InputState, INPUT_STATES.UP);
        }
    }

    onInputMove = (event) => {

        this.touch.delta = (event.changedTouches[0].clientY - this.touch.start);
        let ratio = (this.touch.delta / this.touch.threshold);
        let progress = clamp(ratio, -1, 0);
        let mappedProgress = map(progress, -1, 0, 1, 0);

        this.emit(Events.Progress, mappedProgress);

        if (store.state.swipeup.scrollingLocked) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onResize = () => {
        let vw = window.innerWidth;
        let vh = window.innerHeight;
        this.storeDeviceDimensions(vw, vh);
        this.resize();
    }

    storeDeviceDimensions(vw, vh) {
        let orientation;
        let orientationMinUI;
        if (vh > vw) {
            orientation = 'portrait';
            orientationMinUI = 'portraitMinUI';
        } else {
            orientation = 'landscape';
            orientationMinUI = 'landscapeMinUI';
        }

        // No current size set
        if (!this.deviceDimensions[orientation].height) {
            this.deviceDimensions[orientation].height = vh;
            this.deviceDimensions[orientation].width = vw;
            this.deviceDimensions[orientationMinUI].height = vh;
            this.deviceDimensions[orientationMinUI].width = vw;
            this.emit(Events.Set.Lock, false);
            this.emit(Events.Set.State, STATES.UNKNOWN_STATE); 
            return;
        }

        // Found a new high, assuming min ui
        if (this.deviceDimensions[orientationMinUI].height < vh) {
            this.deviceDimensions[orientationMinUI].height = vh;
            this.deviceDimensions[orientationMinUI].width = vw;
        }

        // Found a new low, assuming out of min ui
        if (this.deviceDimensions[orientation].height > vh) {
            this.deviceDimensions[orientation].height = vh;
            this.deviceDimensions[orientation].width = vw;
        }

        if (this.deviceDimensions[orientation].height === vh) {
            this.emit(Events.Set.Lock, false);
            this.emit(Events.Set.State, STATES.OUT_MIN_UI); 
            return;
        }

        if (this.deviceDimensions[orientationMinUI].height === vh) {
            this.emit(Events.Set.Lock, true);
            this.emit(Events.Set.State, STATES.IN_MIN_UI); 
            return;
        }
        // console.log('Unknown situation, blame Ben');
    }
}
let service = SwipeService;
service.Events = Events
window.SwipeService = service
export default service